import type { ReactNode } from 'react';

interface NoResultsProps {
  icon: ReactNode;
  title: string;
  description: string | JSX.Element;
  className?: string;
}

function NoResults({ icon, title, description, className = '' }: NoResultsProps) {
  return (
    <div data-cy='no-results' className={`flex flex-col justify-center items-center pb-4 ${className}`}>
      <div className='flex justify-center items-center rounded-full bg-gray-200 w-12 h-12 mb-3'>
        <span className='w-[24px] h-[24px] [&>*]:w-full [&>*]:h-full'>{icon}</span>
      </div>
      <p className='text-lg font-bold mb-0'>{title}</p>
      <p className='text-muted text-center'>{description}</p>
    </div>
  );
}

export default NoResults;
